import React from "react";
import { useParams } from "react-router-dom";
import { BookingTracker } from "../components/BookingTracker";
import { useTranslation } from "react-i18next";

export const BookingViewPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  if (!id) {
    return <div>{t("bookings.bookingIdNotFound", "Booking ID not found")}</div>;
  }

  return <BookingTracker bookingId={id} />;
};
